import { render } from "./RequestAccessForm.vue?vue&type=template&id=03d92059"
import script from "./RequestAccessForm.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./RequestAccessForm.vue?vue&type=script&charset=utf-8&lang=js"
script.render = render

export default script